const visitantType = {
    VISITANT:'Visitante',
    EMPLOYEE:"Empleado",
    PROVIDER:"Proveedor",
    MASSIVE_EVENT:"Evento masivo",
    FREQUENT:"Visita frecuente"
}
Object.freeze(visitantType)

export default visitantType;